import { render } from "./PrescriptionGroupNotice.vue?vue&type=template&id=0c2bf3a8&scoped=true"
import script from "./PrescriptionGroupNotice.vue?vue&type=script&lang=js"
export * from "./PrescriptionGroupNotice.vue?vue&type=script&lang=js"

import "./PrescriptionGroupNotice.vue?vue&type=style&index=0&id=0c2bf3a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2bf3a8"]])

export default __exports__